import { Button } from "@/lib/components/Button/Button";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { IconMaximize, IconMinimize } from "@tabler/icons-react";
import { useCallback } from "react";

export default function VideoPreviewFullscreen() {
  const playerRef = useEditorStore((state) => state.service.getPlayerRef());
  const isFullscreen = useEditorStore(
    (state) => state.videoPreviewState.isFullscreen,
  );

  const toggleFullscreen = useCallback(() => {
    if (playerRef?.current?.isFullscreen()) {
      playerRef?.current?.exitFullscreen();
    } else {
      playerRef?.current?.requestFullscreen();
    }
  }, [playerRef]);

  return (
    <Button
      variant="ghost"
      onClick={toggleFullscreen}
      size="iconSm"
      className="text-text-primary [&_svg]:size-5"
    >
      {isFullscreen ? <IconMinimize /> : <IconMaximize />}
    </Button>
  );
}
